var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1619_12418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "evenodd",
    d: "M17.4993 13.3334C17.9267 13.3334 18.2789 13.6551 18.3271 14.0695L18.3327 14.1667V15.8334C18.3327 17.1648 17.2919 18.2531 15.9796 18.3291L15.8327 18.3334H4.16602C2.83461 18.3334 1.7463 17.2926 1.67026 15.9802L1.66602 15.8334V14.1667C1.66602 13.7064 2.03911 13.3334 2.49935 13.3334C2.92671 13.3334 3.27894 13.6551 3.32708 14.0695L3.33268 14.1667V15.8334C3.33268 16.2607 3.65438 16.6129 4.06883 16.6611L4.16602 16.6667H15.8327C16.26 16.6667 16.6123 16.345 16.6604 15.9305L16.666 15.8334V14.1667C16.666 13.7064 17.0391 13.3334 17.4993 13.3334ZM9.99935 1.66669C10.4596 1.66669 10.8327 2.03978 10.8327 2.50002V10.4875L11.9101 9.41076C12.2105 9.11036 12.6832 9.08725 13.0101 9.34144L13.0886 9.41076C13.389 9.71117 13.4121 10.1839 13.1579 10.5108L13.0886 10.5893L10.5886 13.0893L10.552 13.1238L10.4954 13.1697L10.4027 13.2295L10.3088 13.274L10.221 13.3035L10.0972 13.3277L9.99935 13.3334L9.93665 13.331L9.83208 13.3165L9.73923 13.2919L9.64666 13.2553L9.56542 13.2117L9.48539 13.156C9.45896 13.1353 9.43382 13.113 9.41009 13.0893L6.91009 10.5893C6.58466 10.2638 6.58466 9.7362 6.91009 9.41076C7.2105 9.11036 7.68319 9.08725 8.0101 9.34144L8.0886 9.41076L9.16602 10.4875V2.50002C9.16602 2.03978 9.53911 1.66669 9.99935 1.66669Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1619_12418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportButton);
export default __webpack_public_path__ + "static/media/exportButton.913964f7.svg";
export { ForwardRef as ReactComponent };